var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 17.77 17.85 L 15.62 17.85 M 17.77 15.35 L 13.1 15.35 M 17.77 12.85 L 14.62 12.85 M 11.56 4.84 L 11.55 4.84 M 11.55 4.84 L 6.03 4.84 C 4.681 4.84 3.586 5.931 3.58 7.28 L 3.58 9.66 M 11.55 4.84 L 11.8 4.24 C 12.12 3.49 12.855 3.003 13.67 3 L 17.85 3 C 19.6 3 21 4.4 21 6.15 L 21 17.85 C 21 19.6 19.6 21 17.85 21 L 6.15 21 C 4.41 21 3 19.59 3 17.85 L 3 11.48 C 3 10.8 3.21 10.18 3.58 9.66 M 11.55 4.84 C 11.058 6.054 10.466 7.224 9.78 8.34 L 6.15 8.34 C 5.09 8.34 4.15 8.86 3.58 9.66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectS);
export default __webpack_public_path__ + "static/media/project_s.ff8a02fef602290c4e5811b8ef16a93c.svg";
export { ForwardRef as ReactComponent };